// @flow
function convertDate(dateTime: string = ''): Object {

	const [date = '', time = ''] = dateTime?.split(' ') || [];
	const [year = 1, month = 1, day = 1] = date.split('/');
	const [hours = 1, minutes = 1, second = 1] = time.split(':');

	return {
		year: Number(year),
		month: Number(month),
		day: Number(day),
		hours: Number(hours),
		minutes: Number(minutes),
		second: Number(second),
	};
}

export default convertDate;
